/**
 * AlmadarPostWhyWeStartedAlmadarSLAlmadarPostWhyWeStartedAlmadarSLPage
 *
 * Page component for AlmadarPostWhyWeStartedAlmadarSLAlmadarPostWhyWeStartedAlmadarSLPage
 * Path: /sl/blog/why-we-started-almadar
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostWhyWeStartedAlmadarSLPostPageView as __AlmadarPostWhyWeStartedAlmadarSLPostPageView } from '@/components/traits/AlmadarPostWhyWeStartedAlmadarSLPostPageView';
import { AlmadarPostWhyWeStartedAlmadarSLPostAnalyticsView as __AlmadarPostWhyWeStartedAlmadarSLPostAnalyticsView } from '@/components/traits/AlmadarPostWhyWeStartedAlmadarSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostWhyWeStartedAlmadarSLAlmadarPostWhyWeStartedAlmadarSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostWhyWeStartedAlmadarSLAlmadarPostWhyWeStartedAlmadarSLPage(_props: AlmadarPostWhyWeStartedAlmadarSLAlmadarPostWhyWeStartedAlmadarSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostWhyWeStartedAlmadarSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostWhyWeStartedAlmadarSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostWhyWeStartedAlmadarSLAlmadarPostWhyWeStartedAlmadarSLPage;
